export const DEFAULT_SEO = {
  siteUrl: "https://cosylabdesigns.com",
  title: "CosyLab | 香港專業到校興趣班與工作坊",
  description:
    "CosyLab 提供香港到校興趣班、工作坊及學校方案，涵蓋手作、植物護理與社區課程。",
};

const STABLE_ROUTE_META: Record<
  string,
  { title: string; description: string }
> = {
  "/": {
    title: "一站式到校課程 學校方案 | CosyLab - 香港專業到校興趣班與工作坊",
    description:
      "一站式到校課程推薦：CosyLab 提供專業到校興趣班、學校方案、課後興趣班服務。包括蠟燭製作、植物護理等手工藝到校課程，可長期駐校開班，適合中小學及成人團體。",
  },
  "/classes": {
    title: "課程總覽 - CosyLab",
    description: "瀏覽 CosyLab 手作與植物護理課程，適合學校、企業及社區活動。",
  },
  "/portfolio": {
    title: "工作坊目錄 - CosyLab",
    description:
      "瀏覽 CosyLab 工作坊目錄，了解到校課程主題、教學方向與可下載的課程資料。",
  },
  "/about": {
    title: "關於我們 - CosyLab",
    description: "了解 CosyLab 的品牌理念、導師方向與香港到校工作坊服務。",
  },
  "/contact": {
    title: "聯絡我們 - CosyLab",
    description: "聯絡 CosyLab 查詢學校方案、工作坊安排及合作細節。",
  },
  "/partners": {
    title: "合作機構 - CosyLab",
    description: "查看曾與 CosyLab 合作的機構、學校及社區夥伴。",
  },
  "/school-program": {
    title: "學校方案 - CosyLab",
    description: "探索 CosyLab 學校到校課程、手作工作坊與校本活動方案。",
  },
  "/community-program": {
    title: "企業及社區方案 - CosyLab",
    description: "探索 CosyLab 企業及社區工作坊方案，適合團隊及社群活動。",
  },
};

export const PRERENDER_ROUTES = Object.keys(STABLE_ROUTE_META);

export function normalizeCanonicalPath(pathname: string): string {
  const pathOnly = (pathname || "/").split("?")[0].split("#")[0];

  if (!pathOnly || pathOnly === "/") {
    return "/";
  }

  return pathOnly.replace(/\/+$/, "") || "/";
}

function buildCanonical(pathname: string): string {
  return pathname === "/"
    ? `${DEFAULT_SEO.siteUrl}/`
    : `${DEFAULT_SEO.siteUrl}${pathname}`;
}

function getDynamicRouteMetadata(pathname: string) {
  if (/^\/classes\/[^/]+$/.test(pathname)) {
    return {
      title: "課程詳情 - CosyLab",
      description: "查看 CosyLab 課程詳情、作品示例與工作坊安排。課程內容正在更新中。",
      canonical: buildCanonical(pathname),
    };
  }

  return null;
}

export function getRouteMetadata(pathname: string) {
  const normalized = normalizeCanonicalPath(pathname);
  const stableMeta = STABLE_ROUTE_META[normalized];

  if (stableMeta) {
    return {
      ...stableMeta,
      canonical: buildCanonical(normalized),
    };
  }

  const dynamicMeta = getDynamicRouteMetadata(normalized);
  if (dynamicMeta) {
    return dynamicMeta;
  }

  return {
    title: DEFAULT_SEO.title,
    description: DEFAULT_SEO.description,
    canonical: buildCanonical(normalized),
  };
}
